// extracted by mini-css-extract-plugin
export default {"root":"_2s5Dj-Nd","content":"VVidEssJ","buttons":"_1ydxEdLo","backBtn":"_3gOwl-p0"};